import { Flex, Spin } from 'antd';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { authService } from '../services/auth-service';
import { AuthModal } from '../components/auth-modal';
import { DocumentsPageLayout } from '../components/documents-page-layout';

export const SharingDocumentPage = () => {
    const { user_sub } = useParams<{ user_sub: string }>();
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [showAuthModal, setShowAuthModal] = useState(false);
    const [contact, setContact] = useState<string | null>(null);
    const [contactType, setContactType] = useState<'email' | 'phone'>('email');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const initAuth = async () => {
            if (!user_sub) {
                setIsLoading(false);
                return;
            }

            // Check if valid token exists
            if (authService.hasValidToken()) {
                setIsAuthenticated(true);
                setIsLoading(false);
                return;
            }

            // Initiate login process
            try {
                const response = await authService.loginStart(user_sub);
                setContact(response.email || response.phone || null);
                setContactType(response.email ? 'email' : 'phone');
                setShowAuthModal(true);
            } catch (error) {
                console.error('Auth initialization failed:', error);
            } finally {
                setIsLoading(false);
            }
        };

        initAuth();
    }, [user_sub]);

    useEffect(() => {
        if(!showAuthModal && !isAuthenticated){
            setShowAuthModal(true);
        }
    }, [showAuthModal]);

    const handleAuthSuccess = () => {
        setShowAuthModal(false);
        setIsAuthenticated(true);
    };

    const handleAuthCancel = () => {
        setShowAuthModal(false);
    };

    if (isLoading) {
        return (
            <Flex flex={1} justify={'center'} align={'center'} style={{ width: '100%', height: '100%' }}>
                <Spin size="large" />
            </Flex>
        );
    }

    if (!isAuthenticated) {
        return (
            <>
                <Flex flex={1} justify={'center'} align={'center'} style={{ width: '100%', height: '100%' }}>
                    <Spin size="large" />
                </Flex>
                <AuthModal
                    visible={showAuthModal}
                    contact={contact}
                    contactType={contactType}
                    uuid={user_sub || ''}
                    onSuccess={handleAuthSuccess}
                    onCancel={handleAuthCancel}
                />
            </>
        );
    }

    console.log('>>>>', user_sub);
    return (
        <Flex vertical style={{height: '100%'}}>
            <DocumentsPageLayout />
        </Flex>
    );
};
